module.exports = __webpack_public_path__ + "img/google.eb2ffc8d.png";